(() => {
  const drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;

  const overlay = drawer.querySelector('[data-cart-drawer-overlay]');
  const panel = drawer.querySelector('[data-cart-drawer-panel]');
  const body = drawer.querySelector('[data-cart-drawer-body]');
  const footer = drawer.querySelector('[data-cart-drawer-footer]');
  const sectionId = drawer.dataset.sectionId;

  const setOpen = (open) => {
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    drawer.dataset.open = open ? 'true' : 'false';

    if (open) {
      overlay.hidden = false;
      panel.hidden = false;
      document.documentElement.classList.add('overflow-hidden');
      requestAnimationFrame(() => {
        overlay.dataset.open = 'true';
        panel.dataset.open = 'true';
        panel.querySelector('[data-cart-drawer-close]')?.focus();
      });
    } else {
      overlay.dataset.open = 'false';
      panel.dataset.open = 'false';
      document.documentElement.classList.remove('overflow-hidden');
      window.setTimeout(() => {
        if (drawer.dataset.open === 'false') {
          overlay.hidden = true;
          panel.hidden = true;
        }
      }, 300);
    }
  };

  const openDrawer = () => {
    setOpen(true);
    refreshDrawer();
  };

  const closeDrawer = () => setOpen(false);

  const updateCartCount = (count) => {
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.classList.toggle('hidden', count <= 0);
    });
  };

  const bindRemoveButtons = () => {
    drawer.querySelectorAll('[data-cart-drawer-remove]').forEach((button) => {
      button.addEventListener('click', async () => {
        const key = button.dataset.cartDrawerRemove;
        button.disabled = true;

        try {
          await fetch(`${window.Shopify?.routes?.root || '/'}cart/change.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: key, quantity: 0 }),
          });
          await refreshDrawer();
        } catch {
          button.disabled = false;
        }
      });
    });
  };

  const syncFooterVisibility = (itemCount) => {
    if (!footer) return;
    const empty = !itemCount || itemCount <= 0;
    footer.classList.toggle('hidden', empty);
    footer.hidden = empty;
  };

  const refreshDrawer = async () => {
    if (!sectionId) return;

    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}?sections=${sectionId}`);
      const data = await response.json();
      const html = data[sectionId];
      if (!html) return;

      const doc = new DOMParser().parseFromString(html, 'text/html');
      const nextDrawer = doc.querySelector('[data-cart-drawer]');
      if (!nextDrawer) return;

      body.innerHTML = nextDrawer.querySelector('[data-cart-drawer-body]')?.innerHTML || '';
      footer.innerHTML = nextDrawer.querySelector('[data-cart-drawer-footer]')?.innerHTML || '';

      const cartResponse = await fetch(`${root}cart.js`);
      const cart = await cartResponse.json();
      updateCartCount(cart.item_count);
      syncFooterVisibility(cart.item_count);

      bindRemoveButtons();

      const klarnaCart = footer.querySelector('klarna-placement[data-klarna-osm-cart]');
      if (klarnaCart && cart.total_price != null) {
        klarnaCart.setAttribute('data-purchase-amount', String(cart.total_price));
      }
      window.BuxiboKlarnaOsm?.refresh?.();
    } catch {
      /* keep current drawer state on failure */
    }
  };

  document.querySelectorAll('[data-cart-drawer-open]').forEach((trigger) => {
    trigger.addEventListener('click', (event) => {
      event.preventDefault();
      openDrawer();
    });
  });

  drawer.querySelector('[data-cart-drawer-close]')?.addEventListener('click', closeDrawer);
  overlay?.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') {
      closeDrawer();
    }
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-product-form]');
    if (!form) return;

    event.preventDefault();

    const addBtn = form.querySelector('[data-add-to-cart]');
    if (addBtn?.disabled) return;

    const formData = new FormData(form);
    const root = window.Shopify?.routes?.root || '/';

    addBtn.disabled = true;
    const originalText = addBtn.textContent;

    try {
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData,
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.description || 'Could not add to cart');
      }

      await refreshDrawer();
      openDrawer();
    } catch (error) {
      addBtn.textContent = error.message || originalText;
      window.setTimeout(() => {
        addBtn.textContent = originalText;
      }, 3000);
    } finally {
      addBtn.disabled = false;
    }
  });

  bindRemoveButtons();

  fetch(`${window.Shopify?.routes?.root || '/'}cart.js`)
    .then((r) => r.json())
    .then((cart) => {
      updateCartCount(cart.item_count);
      syncFooterVisibility(cart.item_count);
    })
    .catch(() => {});

  window.BuxiboCartDrawer = { open: openDrawer, close: closeDrawer, refresh: refreshDrawer };
})();
